/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PccPatientResponseRaceInner
 */
export interface PccPatientResponseRaceInner {
    /**
     * 
     * @type {string}
     * @memberof PccPatientResponseRaceInner
     */
    raceDesc?: string;
}

/**
 * Check if a given object implements the PccPatientResponseRaceInner interface.
 */
export function instanceOfPccPatientResponseRaceInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PccPatientResponseRaceInnerFromJSON(json: any): PccPatientResponseRaceInner {
    return PccPatientResponseRaceInnerFromJSONTyped(json, false);
}

export function PccPatientResponseRaceInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PccPatientResponseRaceInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'raceDesc': !exists(json, 'raceDesc') ? undefined : json['raceDesc'],
    };
}

export function PccPatientResponseRaceInnerToJSON(value?: PccPatientResponseRaceInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'raceDesc': value.raceDesc,
    };
}

